export enum AssignTypeId {
  Unassigned = 1,
  Patient = 2,
  Staff = 3,
  Asset = 4,
}
